<template>
  <div class="youtaofang">
    <topTitle
      title="柏庭荟"
      :list="list"
      :newData="newData"
      :ContentStatus="ContentStatus"
      :remakTitle="remakTitle"
    ></topTitle>
     <p class="top_p">
      钱湖柏庭外语俱乐部有2个社团，分别是日语社团、英语社团。
    </p>
    <p class="top_p title" style="margin: 0">一、日语社团</p>
    <p class="top_p" style="margin: 0">
      一门语言，一个国家，想象一下，当你与闺蜜团来一场说走就走的浪漫日本樱花游时，用自己平时在日语社团学习的基本会话，与国外友人来一场无障碍交流，也是一件非常值得自豪的事情呢~
    </p>
 
    <div class="item_img">
      <img src="../../assets/image/club/waiyu.jpg" alt="" />
    </div>
     <p class="top_p title" style="margin: 0">二、英语社团</p>
    <p class="top_p" style="margin: 0">
      从世界的角度来看待学习一门除母语外的语言，那就是在学习另外一种文化，学习另外一种逻辑思维方式，学习另外一种思考问题的习惯。
    </p>
    <p class="top_p" style="margin: 0">
      柏庭的英语社团便聚集了这么一群积极生活的人，在此，可以扩展个人视野，了解自己，了解世界~
    </p>
    <!-- <div class="item_bd" v-if="ContentStatus==false">
      <img :src="item.img" alt="" v-for="(item, key) in list2" :key="key" />
    </div>
     <div href="" class="navGet" @click="getHtml('3')" v-if="ContentStatus==false">“最美东钱湖”老年摄影大赛暨钱湖柏庭老年摄影俱乐部成立</div>
     <p v-html="dataContent" v-if="ContentStatus"></p> -->
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
     list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
         {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
         {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
         {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
         {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        }
      ],
      newData:8,
      list2: [
        {
          img: require("../../assets/image/party/item_1.png"),
        },
        {
          img: require("../../assets/image/party/item_2.png"),
        },
        {
          img: require("../../assets/image/party/item_3.png"),
        },
      ],
      dataContent: "",
      ContentStatus: false,
      remakTitle: "",
    };
  },
  methods: {
    getHtml(e) {
      this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
    },
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {
   
  },
};
</script>
<style scoped="scoped">
.title {
  font-weight: 800 !important;
}
p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet {
  display: inline-block;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: underline;
  color: #3f674b;
  line-height: 54px;
  text-align: left;
  margin-top: 0.6rem;
  cursor: pointer;
}
.item_img {
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img > img {
  width: 100%;
  height: auto;
}
</style>